var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"base-body body-1",class:_vm.classes,style:(_vm.styles)},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.text)?_c('div',{domProps:{"textContent":_vm._s(_vm.text)}}):(_vm.html)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }